<template>
    <div class="search">
        <div id="search-bar" class="search-bar" @click="openKeyboard">
            <input
                :disabled="isDisabled"
                type="text"
                inputmode="none"
                v-model="data"
                :placeholder="placeholder"
                @change="onChange"
                @input="onInput"
                @keyup="onKeyup"
                @focus="focusSearchMenu"
                @blur="blurSearchMenu"
            />

            <span class="items-count">{{ itemsCount }}</span>

            <div class="icon" v-if="data.length" @click.stop="clear()">
                <icon-component iconName="clear" />
            </div>

            <div v-else class="icon">
                <icon-component iconName="search_wh" />
            </div>
        </div>

        <teleport to="body">
            <keyboard
                :show-by-default="false"
                :has-blur-action="true"
                :ref="parentComp"
                @clickOnKey="click"
                @clear="click"
            ></keyboard>
        </teleport>
    </div>
</template>

<script>
import Keyboard from "@/components/_shared/Keyboard";
import iconComponent from "@/components/_shared/Icon.vue";

export default {
    name: 'SearchBarComponent',
    props: {
        itemsCount: {
          type: Number,
          required: false,
        },

        placeholder: {
            default: 'Type in ...',
            required: false
        },
        clearInput: {
            default: false,
            required: false
        },
	    parentComp: {
			type: String,
		    required: false,
		    default: 'keyboard'
	    },
	    fromMenu: {
			type: Boolean,
		    required: false,
		    default: false
	    }
    },
    components: {Keyboard, iconComponent},
    data() {
        return {
            data: '',
            isDisabled: false,
        }
    },
    computed: {},
    created() {
    },
    mounted() {
    },
    beforeUnmount() {
    },
	emits: ['onChange', 'onKeyup', 'onInput', 'onClear'],
    methods: {
        focusSearchMenu() {
            if (this.fromMenu) {
                this.emmiter.emit('focusSearchMenu', true);
            }
        },
        blurSearchMenu() {
            if (this.fromMenu) {
                this.emmiter.emit('focusSearchMenu', false);
            }
        },
		clear() {
			this.data = '';
			this.$emit('onClear');
			this.$refs[this.parentComp].closeKeyboard();
		},
        onChange(e) {
            this.$emit('onChange', this.data);
        },
        onKeyup(e) {
	        this.$emit('onKeyup', this.data);
        },
	    onInput(e) {
			this.$emit('onInput', e)
        },
	    click(e) {
		    if (e === undefined) {
			    this.data = this.data.substring(0, this.data.length - 1);
			    let a = {
				    target: {
					    value: this.data
				    }
			    }
				this.onInput(a);
		    } else {
			    this.data += e;
			    let a = {
				    target: {
					    value: this.data
				    }
			    }
			    this.onInput(a);
		    }
	    },
	    openKeyboard() {
			if (this.$refs['ordersList']) {
				this.$refs['ordersList'].closeKeyboard();
			}
			if (this.$refs['menuList']) {
				this.$refs['menuList'].closeKeyboard();
			}
		    this.$refs[this.parentComp].showKeyboard();
	    }
    },
    watch: {
        'clearInput': function (e) {
            if (e) {
                this.data = '';
            }
        },
        data: {
			handler(newValue, oldValue) {
				// console.log(parseInt(newValue.replace( /\D/g, '')));
                
				if (parseInt(newValue.replace( /\D/g, '')).toString().length > 15) {
                    this.isDisabled = true
					this.clear();
                    setTimeout(() => {
                        this.isDisabled = false
                    }, 100);
				} 
            },
        },
    }
}
</script>

<style lang="less" scoped>
.search {
	width: 100%;
	margin-bottom: 10px;
}
#search-bar {
    width: 100%;
    position: relative;
    // background: #F6F6F6;
    input {
        padding: 10px;
        padding-right: 32px;
        width: 100%;
        box-sizing: border-box;
        // background-color: transparent;
        border: 1px solid #777E81;
        border-radius: 6px;
        outline: none;
	    // background: #F6F6F6;
	    background: transparent;
	    &:focus {
		    border-color: var(--theme_color);
	    }
    }
    .icon {
        position: absolute;
        right: 10px;
        top: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        margin-top: -12px;
	    cursor: pointer;
    }

  .items-count {
    position: absolute;
    right: 40px;
    top: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    margin-top: -9px;
    font-size: 12px;
  }
}
</style>
